// removed by extract-text-webpack-plugin
module.exports = {"page":"wmf-1cSs7maD","uploadimg":"wmf-BA5Sxmmx","imgstyle":"wmf-ljpvOfqw","iconstyle":"wmf-10qS2oTi","iconstyles":"wmf-225LyxHm","filestyle":"wmf-At3ypt36"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/commoditymanagement/commodityqualification/commodity-qualification.module.less
// module id = 439
// module chunks = 0